// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2V3iq","footer":"ModalUpdate_footer__2Zmg7"};